import * as actionTypes from './actionTypes'

import { enqueueSnackbar } from './alert'
import userAxios from '../../axios/user'

export const updateProfile = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateProfileStart())

    userAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Profile Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateProfileSuccess())
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Profile User field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateProfileFailed())
      })
  }
}

export const updateProfileStart = () => {
  return {
    type: actionTypes.UPDATE_PROFILE_START
  }
}

export const updateProfileSuccess = () => {
  return {
    type: actionTypes.UPDATE_PROFILE_SUCCESS
  }
}

export const updateProfileFailed = () => {
  return {
    type: actionTypes.UPDATE_PROFILE_FAILED
  }
}
